import React from 'react';
import styles from './UnitRoommates.module.css';

const UnitRoommates = () => {
  const roommateStatus = [
    { name: 'Milo', qualified: true, viewed: true, liked: true },
    { name: 'Theo', qualified: true, viewed: true, liked: null }, // TBD like
    { name: 'Sophie', qualified: false, viewed: null, liked: null}, // TBD viewed
  ];

  const renderIcon = (status) => {
    if (status === true) return "✅";
    if (status === false) return "❌";
    return "➖"; // TBD
  };

  const renderLikeIcon = (status) => {
    if (status === true) return "👍";
    if (status === false) return "❌";
    return "➖"; // TBD
  };

  return (
    <div className={styles.roommateContainer}>
      <h2 className={styles.title}>Roommate Activity</h2>
	  This is for Demonstration. Real Data will come later.

      <table className={styles.roommateTable}>
        <thead>
          <tr>
            <th></th>
            {roommateStatus.map((roommate, idx) => (
              <th key={idx}>
                <div className={styles.headerItem}>
                  <div className={styles.avatar}>{roommate.name[0]}</div>
                  <span>{roommate.name}</span>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Qualified</td>
            {roommateStatus.map((roommate, idx) => (
              <td key={idx}>{renderIcon(roommate.qualified)}</td>
            ))}
          </tr>
          <tr>
            <td>Viewed</td>
            {roommateStatus.map((roommate, idx) => (
              <td key={idx}>{renderIcon(roommate.viewed)}</td>
            ))}
          </tr>
          <tr>
            <td>Liked</td>
            {roommateStatus.map((roommate, idx) => (
              <td key={idx}>{renderLikeIcon(roommate.liked)}</td>
            ))}
          </tr>
        </tbody>
      </table>

		<div className={styles.groupAction}>
		  <div className={styles.inputsRow}>
			<label>
			  Group Move-In Date
			  <input type="date" className={styles.inputField} />
			</label>
			<label>
			  Lease Term
			  <select className={styles.inputField}>
				<option>12 Months</option>
				<option>6 Months</option>
			  </select>
			</label>
		  </div>
		  <button className={styles.submitBtn}>Propose Group Acceptance</button>
		</div>
		<div className={styles.groupMessaging}>
		  <h3>Group Messaging</h3>
		  <div className={styles.messageList}>
			<div className={styles.message}><strong>Milo:</strong> Should we apply now?</div>
			<div className={styles.message}><strong>Theo:</strong> I'm good to go!</div>
		  </div>
		  <textarea 
			className={styles.messageInput} 
			placeholder="Leave a note for the group..."
		  />
		  <button className={styles.sendBtn}>Send Note</button>
		</div>


    </div>
  );
};

export default UnitRoommates;
